import { TBetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { indicator } from "@data-types/bet-booster/indicator";
import { runInAction } from "mobx";

export function resetIndicatorAfterDelay(
	slip: TBetBuilderPick,
	delay: number,
	updateCallback: (slip: TBetBuilderPick) => void,
	timeoutMap: Map<string, ReturnType<typeof setTimeout>>
) {
	const timeoutId = setTimeout(() => {
		runInAction(() => {
			slip.indicator = 0;
			updateCallback(slip);
		});
	}, delay);

	runInAction(() => {
		timeoutMap.set(slip.id, timeoutId);
	});
}

export function updateSlipIndicator(
	slip: TBetBuilderPick,
	existingSlip: TBetBuilderPick | undefined
) {
	runInAction(() => {
		let indicator: indicator = 0;
		if (existingSlip) {
			if (slip.bbMaxCoefficient < existingSlip.bbMaxCoefficient) {
				indicator = -1;
			} else if (slip.bbMaxCoefficient > existingSlip.bbMaxCoefficient) {
				indicator = 1;
			}
		}
		slip.indicator = indicator;
	});
}
